
















































































/**
 * @copyright       Palace Resorts
 * @description     Pantalla modal edit
 */
import i18nMessages from "./i18n/messages";
import GlobalMixin from "@/mixins/global";
import dataService from "@/services/proveedoresAPI";
import ResponseData from "@/models/store/ProveedoresTypesData";
import Snackbar from "@/components/ModalFormNewResgister/snackbar.vue";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  components: {
    Snackbar,
  },
  props: {
    dialog: { type: Boolean, default: false },
  },
  data: () => ({
    person: {
      userID: "",
      userName: "",
    },
    personOptions: [] as any,
    search: "",
    loadingPersons: false,
    params: "",
    descriptionLimit: 60,
    link: "/registra-contrato/",
    registraContrato: "",
    // GENERAL
    moduleName: "DIALOG_CHOOSE_PROVIDER",
    snackbar1: false,
    text1: "",
    userID: null as any,
    isLoading: false,
  }),
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    openDialog() {
      this.$emit("openDialog");
    },
    closeSnackbar() {
      this.snackbar1 = false;
    },
    chooseProvider() {
      this.userID = this.person.userID;
      this.registraContrato = this.link + this.userID;
    },
    async getdata(val: any) {
      dataService
        .getAllProvider(0, 10, val)
        .then((Response: ResponseData) => {
          this.personOptions = Response.data.data[0].data[0];
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },

    filterFuncion(item: any, queryText: any, itemText: any) {
      return (
        item.userID.toLowerCase().includes(queryText.toLowerCase()) ||
        item.userName.toLowerCase().includes(queryText.toLowerCase())
      );
    },
  },
  watch: {
    search(val: string) {
      // Items have already been requested
      if (this.isLoading) return;
      this.isLoading = true;
      this.getdata(val);
    },
  },
});
